/** @format */

import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { BreakPoint } from '@shared/data-access/enums';
import { DeviceService } from '@shared/data-access/services';
import { HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import { ProductRecommendationsComponent } from '../product-recommendations/product-recommendations.component';

@Component({
  selector: 'shared-components-drawer-product-recommendations',
  imports: [HmfDrawerComponent, ProductRecommendationsComponent],
  templateUrl: './drawer-product-recommendations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './drawer-product-recommendations.component.scss',
})
export class DrawerProductRecommendationsComponent implements OnInit {
  @Input() drawerId?: string;
  @Input() headerText?: string;
  @Input() filterBy: string;
  @Input() showQVButtons?: boolean;
  // Remove when all product info is in hmf-product-card
  @Input() showVerticalLegacy?: boolean;

  // Emit event when the drawer is closed
  @Output() closeDrawerProductRecommendations = new EventEmitter<void>();
  // Emit event when quick view is clicked
  @Output() quickViewClick = new EventEmitter<string>();

  @ViewChild('drawer') drawerComponent: HmfDrawerComponent | undefined;

  showDrawer = true;
  showProductRecommendations = false;
  isMobile = false;

  constructor(private deviceService: DeviceService) {}

  ngOnInit(): void {
    this.onResize();
  }

  openDrawer(): void {
    this.drawerComponent?.openDrawer();
    this.showProductRecommendations = true;
  }

  closeDrawer(): void {
    this.closeDrawerProductRecommendations.emit();
    this.showProductRecommendations = false;
  }

  openQuickviewPanel(ecode: string): void {
    this.quickViewClick.emit(ecode);
  }

  @HostListener('window:resize', [])
  public onResize(): void {
    const breakpoint = this.deviceService.getDeviceBreakPoint(true);
    this.isMobile = breakpoint === BreakPoint.EXTRASMALL || breakpoint === BreakPoint.SMALL;
  }
}
